var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "flex flex-col w-1/2 px-4 py-0 pb-3"
  }, [_c('div', [_c('FormLabel', {
    attrs: {
      "htmlFor": "name_group",
      "className": "mt-3"
    }
  }, [_vm._v(" Publisher Group Name ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.name,
      expression: "form.name"
    }],
    staticClass: "w-full rounded-md px-3 py-2.5 mb-1 text-sm",
    class: ['border rounded px-3 py-2 w-full', _vm.invalidName || _vm.invalidNameEmpty ? 'bg-red-300 text-red-700 border-red-400 placeholder-red-500' : 'bg-gray-50 text-gray-700 border-gray-300'],
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter Publisher Group Name"
    },
    domProps: {
      "value": _vm.form.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value);
      }
    }
  }), _vm.invalidName ? _c('p', {
    staticClass: "text-red-600 text-sm mt-1"
  }, [_vm._v(" Publisher Group name already exist. ")]) : _vm._e(), _vm.invalidNameEmpty ? _c('p', {
    staticClass: "text-red-600 text-sm mt-1"
  }, [_vm._v(" Must be filled. ")]) : _vm._e()], 1), _c('div', [_c('FormLabel', {
    attrs: {
      "htmlFor": "publisher",
      "className": "mt-3"
    }
  }, [_vm._v(" Publisher ")]), _c('multiselect', {
    staticClass: "box-border custom-multiselect",
    class: _vm.invalidVendorsEmpty ? 'error' : '',
    attrs: {
      "label": "name",
      "track-by": "name",
      "placeholder": "Select Publisher",
      "open-direction": "bottom",
      "options": _vm.items_vendor,
      "searchable": true,
      "loading": _vm.isLoadingSearch,
      "close-on-select": true,
      "multiple": true
    },
    on: {
      "search-change": _vm.findVendorName
    },
    scopedSlots: _vm._u([{
      key: "tag",
      fn: function (_ref) {
        var option = _ref.option,
          remove = _ref.remove;
        return [_c('span', {
          staticClass: "inline-flex items-center text-sm font-medium rounded px-2 py-1 mr-1 mb-1 border",
          class: _vm.vendorsAlready.includes(option.id) ? 'bg-red-100 text-red-700 border-red-400' : 'bg-blue-100 text-blue-700 border-blue-300'
        }, [_vm._v(" " + _vm._s(option.name) + " "), _c('button', {
          staticClass: "ml-1 text-xs font-bold focus:outline-none",
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.removeAndUpdateInvalid(option, remove);
            }
          }
        }, [_vm._v(" ✕ ")])])];
      }
    }]),
    model: {
      value: _vm.form.vendors,
      callback: function ($$v) {
        _vm.$set(_vm.form, "vendors", $$v);
      },
      expression: "form.vendors"
    }
  }, [_c('span', {
    staticClass: "text-gray-500",
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(" Oops! No elements found. Consider changing the search query. ")])]), _vm.vendorsAlready.length ? _c('p', {
    staticClass: "text-red-600 text-sm mt-1"
  }, [_vm._v(" Publisher is already registered in another Publisher Group. ")]) : _vm._e(), _vm.invalidVendorsEmpty ? _c('p', {
    staticClass: "text-red-600 text-sm mt-1"
  }, [_vm._v(" Must be filled. ")]) : _vm._e()], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }